import { Builder } from '@builder.io/react';
import React, { useEffect, useState } from "react";
import { BuilderComponent } from "@builder.io/react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { builderClient } from '@/utils/builder';
import { reportError } from '@/helpers/errorHelper';
import dynamic from 'next/dynamic';
import useMediaQuery from '@/helpers/hooks/useMediaQuery';

const PLPQuickLinks = (props) => {
  const [builderContentJson, setBuilderContentJson] = useState(null);
  let [textQuickLinks, setTextQuickLinks] = useState('');
  const router = useRouter();
  const isApp = useSelector((state) => state.pwa.is_PWA);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    try {
      builderClient
        .get("image-quick-links", {
          userAttributes: {
            urlPath: props.serverPath,
            app: isApp,
          },
        })
        .promise()
        .then((res) => {
          if(res){
            setBuilderContentJson(res);
          }
        })
        .catch((err) => {
          reportError("Builder Image Quick Links error:", err);
        });
    } catch (err) {
      reportError("Builder Image Quick Links error:", err);
    }
  }, [props.serverPath, isApp]);

  useEffect(()=>{
    const imageQuickLinks = builderContentJson?.data?.blocks[0]?.component?.options?.imageQuickLinks || [];
    const hasAllProducts = (device) => {
      return imageQuickLinks.every(link => {
        switch (device) {
          case 'desktop':
            return Boolean(link?.desktopProduct?.options?.product);
          case 'tablet':
            return Boolean(link?.tabletProduct?.options?.product);
          case 'mobile':
            return Boolean(link?.mobileProduct?.options?.product);
          default:
            return false;
        }
      });
    };

    // Determine which device is missing products
    const isDesktopMissing = hasAllProducts('desktop');
    const isTabletMissing = hasAllProducts('tablet');
    const isMobileMissing = hasAllProducts('mobile');
  
    // Set the textQuickLinks variable if any device is missing products
    if ((isDesktopMissing && isDesktop )|| (isTabletMissing && isTablet) || (isMobileMissing && isMobile)) {
      setTextQuickLinks('text-quick-links');
    }  
    else {
      setTextQuickLinks('');
    }

  },[builderContentJson,isMobile,isTablet,isDesktop]);
  
  return (
    <div className={`image-quick-links ${textQuickLinks?'text-quick-links':''}`}>
      {builderContentJson &&
        <BuilderComponent model="image-quick-links" content={builderContentJson} />}
    </div>
  );
};

const ImageQuickLinks = dynamic(async () => {
    return (await import("./ImageQuickLinks")).default;
});

Builder.registerComponent(ImageQuickLinks, {
  name: 'Image quick links',
  inputs: [
    {
        name: 'imageQuickLinks',
        type: 'list',
        helperText: 'Quick Links for PLP',
        subFields: [
            {
                name: 'desktopDisplayText',
                type: 'string',
                helperText: 'Text displayed on the desktop website',
            },
            {
                name: 'desktopUrl',
                type: 'url',
                helperText: 'URL the customer is redirected to when they click on the quick link from desktop',
            },
            {
                name: 'desktopProduct',
                type: "ShopifyProduct",
                helperText: "Primary image displayed for the quick link on desktop",
            },
            {
                name: 'tabletDisplayText',
                type: 'string',
                helperText: 'Text displayed on the tablet website',
            },
            {
                name: 'tabletUrl',
                type: 'url',
                helperText: 'URL the customer is redirected to when they click on the quick link from tablet',
            },
            {
                name: 'tabletProduct',
                type: "ShopifyProduct",
                helperText: "Primary image displayed for the quick link on tablet",
            },
            {
                name: 'mobileDisplayText',
                type: 'string',
                helperText: 'Text displayed on the mobile website',
            },
            {
                name: 'mobileUrl',
                type: 'url',
                helperText: 'URL the customer is redirected to when they click on the quick link from mobile',
            },
            {
                name: 'mobileProduct',
                type: "ShopifyProduct",
                helperText: "Primary image displayed for the quick link on mobile",
            },
        ],
    },
  ],
});

export default PLPQuickLinks;